/* eslint-disable @typescript-eslint/no-unused-vars */
import { postAuth, getAuth } from "@/core/config/ApiService";

import { postUpload } from "@/core/config/ApiService";
import { upload } from "@/core/services/UploadImage/upload";

class Transaction {
  async transactionsLists(
    startDate: string,
    endDate: string,
    status: string
  ): Promise<any> {
    const params = new URLSearchParams({
      start_date: startDate,
      end_date: endDate,
    });

    const resp = await getAuth(`api/crm/transactions?${params.toString()}`);
    return resp.data;
  }

  async pay(data: any): Promise<any> {
    const resp = await postAuth("api/crm/pay", data);
    return resp.data;
  }

  async payDetail(data: any): Promise<any> {
    const resp = await postAuth("api/crm/payment/detail", data);
    return resp.data;
  }

  async uploadSlip(formData: FormData) {
    return await postUpload("api/crm/upload-slip", formData);
  }

  async reports(data: any): Promise<any> {
    const resp = await postAuth("api/crm/transactions/report", data);
    return resp.data;
  }
  async reportsDetail(data: any): Promise<any> {
    const resp = await postAuth("api/crm/transactions/details", data);
    return resp.data;
  }

  async crypto(data: any): Promise<any> {
    const resp = await postAuth("api/crm/transaction/detail", data);
    return resp.data;
  }

  async providerReport(data: any): Promise<any> {
    const resp = await postAuth("api/crm/transactions/provider-report", data);
    return resp.data;
  }

  async reportTransactionSubmit(data: any): Promise<any> {
    const resp = await postAuth("api/crm/transaction/submit", data);
    return resp.data;
  }

  async reportRemaining(data: any): Promise<any> {
    const resp = await postAuth("api/crm/transactions/remaining", data);
    return resp.data;
  }

  async resolveSubmit(data: any): Promise<any> {
    const resp = await postAuth("api/crm/transaction/resolve", data);
    return resp.data;
  }

  async updateRemaining(data: any): Promise<any> {
    const resp = await postAuth("api/crm/transaction/update", data);
    return resp.data;
  }

  async transactionsListsAll(
    startDate: string,
    endDate: string,
    status?: string,
    provider?: string
  ): Promise<any> {
    const query: Record<string, string> = {
      start_date: startDate,
      end_date: endDate,
    };

    if (status !== undefined && status !== null && status !== "") {
      query.status = status.toString();
    }

    if (provider !== undefined && provider !== null && provider !== "") {
      query.provider = provider;
    }

    const params = new URLSearchParams(query);

    const resp = await getAuth(
      `api/crm/transactions/list?${params.toString()}`
    );
    return resp.data;
  }
}

export default new Transaction();
